/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import { Carousel as AntCarousel } from 'antd';
import { CarouselRef } from 'antd/lib/carousel';
import { forwardRef, MutableRefObject, useRef, useState } from 'react';

import { useDisplayContext } from '~src/context/DisplayContext';

import { Pagination } from './components/Pagination';
import { Chevron, ChevronContainer, Container } from './style';
import { Props } from './types';

export const Carousel = forwardRef<CarouselRef, Props>(function Carousel(
  { items, type = 'dots', hover = true, style },
  reference
) {
  const [page, setPage] = useState<number>(0);
  const { deviceType } = useDisplayContext();

  const innerReference = useRef<CarouselRef>(null);
  const carouselReference = (reference as MutableRefObject<CarouselRef | null>) ?? innerReference;

  if (['dots', 'dots-white', 'dots-norlys'].includes(type)) {
    return (
      <div style={style}>
        <AntCarousel afterChange={setPage} dots={false} draggable ref={carouselReference}>
          {items.map(item => (
            <Container key={item?.toString()}>{item}</Container>
          ))}
        </AntCarousel>

        {items.length > 0 && (
          <Pagination
            style={{ marginTop: deviceType === 'SMALL_MOBILE' ? '-8px' : '8px' }}
            total={items.length}
            current={page}
            type={type}
          />
        )}
      </div>
    );
  }

  const showPageArrows = items.length > 1;

  return (
    <ChevronContainer style={{ padding: 0, width: '100%', marginLeft: 0, ...style }}>
      {!!showPageArrows && (
        <>
          <div onClick={() => carouselReference?.current?.prev()}>
            <Chevron hover={hover} direction='left' />
          </div>

          <div onClick={() => carouselReference?.current?.next()}>
            <Chevron style={{ right: 0 }} hover={hover} direction='right' />
          </div>
        </>
      )}

      <AntCarousel ref={carouselReference} dots={false} draggable>
        {items.map(item => (
          <Container key={item?.toString()}>{item}</Container>
        ))}
      </AntCarousel>
    </ChevronContainer>
  );
});
